// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import type { RelatedLinksProps } from '@dip/helsecore/src/components/parts/RelatedLinks/RelatedLinks.d';

import React from 'react';
import { RelatedLinks } from '@dip/helsecore/src/components/parts/RelatedLinks/RelatedLinks';

export default (props: Readonly<RelatedLinksProps>) => <RelatedLinks {...props} />
